// initial state
const state = {
  product: {}
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  setProduct (state, product) {
    state.product = product
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/js/store/modules/product.js